/**
 * consent-offset.js
 *
 * La bannière de consentement aux cookies de Shopify (#shopify-pc__banner) s'affiche
 * en bas de l'écran avec un z-index très élevé (2 000 000). Sur mobile elle occupe
 * près de la moitié de la hauteur : la barre d'achat collante de la fiche produit et
 * le bouton « Paiement » du tiroir panier passent dessous et deviennent intouchables
 * tant que le visiteur n'a pas répondu à la bannière.
 *
 * Ce script décale ces deux éléments juste au-dessus de la bannière, et remet tout
 * en place dès qu'elle disparaît. Rien n'est masqué : la bannière reste entièrement
 * visible et cliquable, seuls les boutons d'achat remontent.
 */
(function () {
  'use strict';

  var BANNER = '#shopify-pc__banner';
  var POLL_FAST = 600;   // ms, pendant les 30 premières secondes
  var POLL_SLOW = 2500;  // ms, ensuite
  var started = Date.now();

  function bannerRect() {
    var el = document.querySelector(BANNER);
    if (!el) return null;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return null;
    var r = el.getBoundingClientRect();
    if (r.height < 10 || r.width < 10) return null;
    // uniquement si elle est bien ancrée en bas de l'écran
    if (r.bottom < window.innerHeight - 40) return null;
    return r;
  }

  // Chevauchement horizontal entre la zone cliquable et la bannière.
  // On teste les boutons, pas le conteneur : sur ordinateur la bannière est centrée
  // et ne recouvre pas les boutons placés à droite, inutile de décaler quoi que ce soit.
  function overlapsX(el, br, inner) {
    var target = (inner && el.querySelector(inner)) || el;
    var r = target.getBoundingClientRect();
    if (r.width < 10) return false;
    return !(r.right <= br.left + 1 || r.left >= br.right - 1);
  }

  function shiftFor(br) {
    return Math.max(0, Math.round(window.innerHeight - br.top));
  }

  function apply() {
    var br = bannerRect();
    var shift = br ? shiftFor(br) : 0;

    // 1. Barre d'achat collante de la fiche produit (fixed, bottom:0)
    var bars = document.querySelectorAll('.product-sticky-cart');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var want = (shift && overlapsX(bar, br, 'button[name="add"]')) ? shift : 0;
      if (String(bar.dataset.consentShift || '0') === String(want)) continue;
      bar.dataset.consentShift = want;
      bar.style.bottom = want ? want + 'px' : '';
    }

    // 2. Pied du tiroir panier (sous-total + boutons Boutique / Paiement)
    var feet = document.querySelectorAll('.mini-cart__footer');
    for (var j = 0; j < feet.length; j++) {
      var foot = feet[j];
      var w = (shift && overlapsX(foot, br, '.button-container')) ? shift : 0;
      if (String(foot.dataset.consentShift || '0') === String(w)) continue;
      foot.dataset.consentShift = w;
      if (w) foot.style.paddingBottom = 'calc(2rem + ' + w + 'px)';
      else foot.style.paddingBottom = '';
    }
  }

  function tick() {
    try { apply(); } catch (e) {}
    var delay = (Date.now() - started < 30000) ? POLL_FAST : POLL_SLOW;
    setTimeout(tick, delay);
  }

  // Réagir tout de suite aux événements qui comptent
  ['resize', 'orientationchange', 'cart:updated'].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(apply, 60); });
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest(BANNER)) setTimeout(apply, 120);
  }, true);
  document.addEventListener('visitorConsentCollected', function () { setTimeout(apply, 120); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick);
  else tick();
})();
